import { toast } from 'react-toastify';
import { apiSubmit } from '../main';

export const apiRequestToastAsync = ({ request_details, messages = { loading: 'Loading...', done: 'Loaded.', error: 'Loading failed!' } }) => {
    return new Promise(async (resolve, reject) => {
      let response = null;
  
      try {
        var loading = toast.loading(messages.loading, {
          closeOnClick: true,
          closeButton: true
        });
        
        response = await apiSubmit(request_details);

        console.log('apiRequestToastAsync.response', response);
        
        if (response) {
          toast.update(loading, {
            render: messages.done,
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
        }
  
        resolve(response);
  
      } catch (error) {
        console.log('apiRequestToastAsync.error', error);
        response = (error.error && `${error.error.status}: ${error.error.message}`) || error.message || error;
        
        toast.update(loading, {
          render: response.message || response,
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
  
        reject(error.error || error.message || error);
      }
    });
  };
  